import { render, staticRenderFns } from "./PetDisplay.vue?vue&type=template&id=0c0f5480&scoped=true&"
import script from "./PetDisplay.vue?vue&type=script&lang=js&"
export * from "./PetDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PetDisplay.vue?vue&type=style&index=0&id=0c0f5480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f5480",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
